// extracted by mini-css-extract-plugin
export default {"empty_message":"empty_empty_message__Vsfuq","halfHeight":"empty_halfHeight__dLrbq"};